document.addEventListener("DOMContentLoaded", function() {
    function preselectFirstRadioButton(groupSelector) {
        const radioGroups = document.querySelectorAll(groupSelector);
        radioGroups.forEach(group => {
            const firstOption = group.querySelector("input[type='radio']");
            if (firstOption) {
                firstOption.checked = true;
                firstOption.dispatchEvent(new Event("click", { bubbles: true }));
            }
        });
    }

    function preselectFirstDropdown(selector) {
        const dropdown = document.querySelector(selector);
        if (dropdown) {
            dropdown.selectedIndex = 0;
            dropdown.dispatchEvent(new Event("change", { bubbles: true }));
        }
    }

    // Ensure all variant groups are properly preselected
    preselectFirstRadioButton(".product-form__input"); // Covers Color, Size, and Quantity if using radio buttons
    preselectFirstDropdown(".product-form__input select"); // Covers dropdown-based selectors if present
});


function updateColorName(selected) {
  let colorName = selected.value;
  document.getElementById("selected-color-name").textContent = colorName;
}

// Set default selected color on page load
document.addEventListener("DOMContentLoaded", function () {
  let defaultColor = document.querySelector(".variant-swatch-input:checked");
  if (defaultColor) {
    updateColorName(defaultColor);
  }
});
